"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.presentProfileViewModel = presentProfileViewModel;
var _selectors = require("./sections/social/selectors");
var _selectors2 = require("./sections/skills/selectors");
var _selectors3 = require("./sections/languages/selectors");
var _selectors4 = require("./sections/resume/selectors");
var _selectors5 = require("./sections/contactInfo/selectors");
var _selectors6 = require("./sections/education/selectors");
var _selectors7 = require("./sections/projects/selectors");
var _selectors8 = require("./sections/heading/selectors");
var _selectors9 = require("./sections/bio/selectors");
async function presentProfileViewModel(subject, store) {
  const profileDetails = (0, _selectors8.presentProfile)(subject, store);
  const contactInfo = (0, _selectors5.presentContactInfo)(subject, store);
  const skills = (0, _selectors2.presentSkillDetails)(subject, store);
  const languages = (0, _selectors3.presentLanguages)(subject, store);
  const education = (0, _selectors6.presentEducation)(subject, store);
  const projects = await (0, _selectors7.presentProjects)(subject, store);
  const bioDetails = (0, _selectors9.presentBio)(subject, store);
  const social = (0, _selectors.presentSocial)(subject, store);
  const cvDetails = (0, _selectors4.presentCV)(subject, store);
  return {
    profileDetails,
    social,
    contactInfo,
    skills,
    languages,
    education,
    projects,
    bioDetails,
    cvDetails
  };
}